export const skeleton = {
  hidden: "pointer-events-none hidden",
  invisible: "pointer-events-none invisible",
  nonInteractive: "pointer-events-none animate-pulse",
  heading: "pointer-events-none animate-pulse text-subtle",
  text: "pointer-events-none animate-pulse text-transparent bg-gray-200 border-gray-200 rounded-md shadow-none",
  button: "pointer-events-none animate-pulse text-transparent! bg-gray-200! rounded-full! shadow-none!",
} as const
